/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

import styles from './Present.module.css';

const StorySnow = () => {
  useEffect(() => {
    (function () {
      const canvas = document.getElementById(
        'present-canvas'
      ) as HTMLCanvasElement;
      const ctx = canvas?.getContext('2d');

      if (!ctx) {
        return;
      }

      let width: number, height: number, lastNow: number;
      let snowflakes: any;
      let maxSnowflakes = 100;

      function init() {
        snowflakes = [];
        resize();
        render((lastNow = performance.now()));
      }

      function render(now: number) {
        requestAnimationFrame(render);
        if (!ctx) {
          return;
        }

        const elapsed = now - lastNow;
        lastNow = now;

        ctx?.clearRect(0, 0, width, height);
        if (snowflakes.length < maxSnowflakes) snowflakes.push(new Snowflake());

        ctx.fillStyle = ctx.strokeStyle = 'rgba(255, 255, 255, .5)';

        snowflakes.forEach(
          (snowflake: { update: (arg0: number, arg1: any) => any }) =>
            snowflake.update(elapsed, now)
        );
      }

      function resume() {
        lastNow = performance.now();
        requestAnimationFrame(render);
      }

      class Snowflake {
        x!: number;
        y!: number;
        xVel!: number;
        yVel!: number;
        angle!: number;
        angleVel!: number;
        size!: number;
        sizeOsc: number | undefined;
        constructor() {
          this.spawn();
        }

        spawn(anyY = false) {
          this.x = rand(0, width);
          this.y = anyY === true ? rand(-50, height + 50) : rand(-50, -10);
          this.xVel = rand(-0.05, 0.05);
          this.yVel = rand(0.02, 0.1);
          this.angle = rand(0, Math.PI * 2);
          this.angleVel = rand(-0.001, 0.001);
          this.size = rand(7, 12);
          this.sizeOsc = rand(0.01, 0.5);
        }

        update(elapsed: number, now: any) {
          const xForce = rand(-0.001, 0.001);

          if (Math.abs(this.xVel + xForce) < 0.075) {
            this.xVel += xForce;
          }

          this.x += this.xVel * elapsed;
          this.y += this.yVel * elapsed;
          this.angle += this.xVel * 0.05 * elapsed; //this.angleVel * elapsed

          if (
            this.y - this.size > height ||
            this.x + this.size < 0 ||
            this.x - this.size > width
          ) {
            this.spawn();
          }

          this.render();
        }

        render() {
          if (!ctx) {
            return;
          }
          ctx.save();
          const { x, y, angle, size } = this;
          ctx.beginPath();
          ctx.arc(x, y, size * 0.2, 0, Math.PI * 2, false);
          ctx.fill();
          ctx.restore();
        }
      }

      // Utils
      const rand = (min: number, max: number) =>
        min + Math.random() * (max - min);

      function resize() {
        width = canvas.width;
        height = canvas.height;
        maxSnowflakes = Math.max(width / 10, 100);
      }

      function cleanup() {
        // Cleanup function to cancel the animation frame and hide the canvas
        if (canvas) {
          canvas.style.display = 'none'; // Hide the canvas when unmounted
        }
      }

      window.addEventListener('resize', resize);
      window.addEventListener('focus', resume);
      init();

      return cleanup;
    })();
  }, []);

  return (
    <>
      <canvas className={styles['canvas-story']} id={'present-canvas'}></canvas>
    </>
  );
};

export default StorySnow;
